module.exports = __webpack_public_path__ + "img/human-resources.fe39ea1b.png";